const integration = {
  INSUFFICIENT_BALANCE: {
    message: 'Insufficient balance in the account for the operation.',
    code: 'STI_1'
  },
  VALUE_MUST_NOT_BE_ZERO: {
    message: 'Value must be different from zero.',
    code: 'STI_2'
  },
  PIX_CHARGEBACK_EXCEEDS_VALUE: {
    message: 'Chargebacks sum exceeds received PIX value.',
    code: 'STI_3'
  },
  PIX_CHARGEBACK_DEADLINE_EXCEEDED: {
    message: 'PIX received for more than 90 days, chargeback is not possible.',
    code: 'STI_4'
  },
  PIX_CHARGEBACK_DUPLICATED: {
    message: 'Chargeback id already exists.',
    code: 'STI_5'
  },
  CANT_MODIFY_ENTRY_TYPE: {
    message: "It's not allowed to change the type of this entry",
    code: 'STI_6'
  },
  CANT_MODIFY_ENTRY: {
    message: "It's not allowed to modify this entry",
    code: 'STI_7'
  }
};

module.exports = integration;
